import { useQuery } from "@tanstack/react-query";
import { useLiveQuery } from "dexie-react-hooks";
import { getClienteCarteira } from "~services/WalletServices";
import { db } from "~db/db";

export const useGetClientData = (id, enabled = true) => {
  const numericId = id ? parseInt(id) : null;

  const dbData = useLiveQuery(
    () => numericId ? db.cliente.get(numericId) : null,
    [numericId],
    null
  );

  const apiQuery = useQuery(
    ["clienteCarteira", id], 
    async () => {
      const apiData = await getClienteCarteira(id);
      
      if (apiData && numericId) {
        const clienteLocal = await db.cliente.get(numericId);
        await db.cliente.put(clienteLocal
          ? { ...clienteLocal, ...apiData, id: numericId, clienteCarteira: clienteLocal.clienteCarteira, clienteProspect: clienteLocal.clienteProspect, recebedor: clienteLocal.recebedor }
          : { ...apiData, id: numericId });
      }
      
      return apiData;
    },
    {
      enabled: enabled && !!id,
    }
  );

  return {
    data: dbData || apiQuery.data,
    isLoading: !dbData && apiQuery.isLoading,
    error: apiQuery.error,
    isSuccess: !!dbData || apiQuery.isSuccess,
    isFetching: apiQuery.isFetching,
    refetch: apiQuery.refetch
  };
};